import { createAction, props, createReducer, on, createFeatureSelector, createSelector, Store, StoreModule, StoreFeatureModule } from '@ngrx/store';
import { CommonModule, AsyncPipe, NgClass, NgIf } from '@angular/common';
import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Inject, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵdirectiveInject, ViewContainerRef, ɵɵdefineDirective, Directive, ɵɵdefineComponent, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, ɵɵpipe, ɵɵelement, ɵɵadvance, ɵɵproperty, ɵɵpipeBind1, Component, ViewChild, ɵɵpureFunction1, ɵɵtextInterpolate, ɵɵelementContainerStart, ɵɵtemplate, ɵɵelementContainerEnd, ɵɵnextContext, ComponentFactoryResolver, ɵɵstaticViewQuery } from '@angular/core';
import { createEffect, ofType, Actions, EffectsModule, EffectsFeatureModule } from '@ngrx/effects';
import { HttpClient, HttpBackend, HttpClientModule } from '@angular/common/http';
import { switchMap, concatMap, map, catchError, tap, mapTo, startWith, takeWhile, withLatestFrom, filter } from 'rxjs/operators';
import { EMPTY, of, BehaviorSubject, combineLatest, fromEvent } from 'rxjs';
import { CardHeaderComponent, ButtonComponent, CardContentComponent, TextInputComponent, CardComponent, CardFooterComponent, CardModule, TextInputModule, ButtonModule } from 'elements-lib';
import { RouterModule } from '@angular/router';

const loadUser = createAction('[User] Load User', props());
const userLoaded = createAction('[User] User Loaded', props());
const loadUserSuccess = createAction('[User] Load User Success', props());
const loadUserFailure = createAction('[User] Load User Failure', props());
const noLocalUser = createAction('[User] No Local User');
const signIn = createAction('[User] Sign In', props());
const signInSuccess = createAction('[User] Sign In Success', props());
const signInFail = createAction('[User] Sign In Fail', props());
const changePassword = createAction('[User] Change Password', props());
const changePasswordSuccess = createAction('[User] Change Password Success', props());
const changePasswordError = createAction('[User] Change Password Error', props());
const sessionExpired = createAction('[User] Session Expired');
const signOut = createAction('[User] Sign Out', props());

var user_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    loadUser: loadUser,
    userLoaded: userLoaded,
    loadUserSuccess: loadUserSuccess,
    loadUserFailure: loadUserFailure,
    noLocalUser: noLocalUser,
    signIn: signIn,
    signInSuccess: signInSuccess,
    signInFail: signInFail,
    changePassword: changePassword,
    changePasswordSuccess: changePasswordSuccess,
    changePasswordError: changePasswordError,
    sessionExpired: sessionExpired,
    signOut: signOut
});

const userFeatureKey = 'user';
var Step;
(function (Step) {
    Step["Authenticated"] = "[Authenticated]";
    Step["Unauthenticated"] = "[Unauthenticated]";
    Step["Initial"] = "[Initial]";
    Step["SignIn"] = "[SignIn]";
    Step["LoadUser"] = "[LoadUser]";
    Step["ChangePassword"] = "[ChangePassword]";
})(Step || (Step = {}));
const initialState = {
    loggedIn: false,
    inProgress: true,
    name: null,
    token: null,
    permissions: null,
    groups: [],
    step: Step.Initial
};
const reducer = createReducer(initialState, on(loadUser, state => (Object.assign(Object.assign({}, state), { inProgress: true, error: null, step: Step.LoadUser }))), on(loadUserSuccess, (state, action) => (Object.assign(Object.assign({}, state), { inProgress: false, error: null, step: Step.Authenticated }))), on(loadUserFailure, (state, { error }) => (Object.assign(Object.assign({}, initialState), { inProgress: false, error, step: Step.LoadUser }))), on(noLocalUser, state => {
    return Object.assign(Object.assign({}, state), { inProgress: false, error: null, step: Step.Unauthenticated });
}), on(signIn, state => {
    return Object.assign(Object.assign({}, state), { inProgress: true, error: null, step: Step.SignIn });
}), on(signInFail, (state, { error }) => {
    const changePasswordRequired = error && error.status === 403;
    const step = changePasswordRequired ? Step.ChangePassword : Step.SignIn;
    return Object.assign(Object.assign({}, initialState), { inProgress: false, error,
        step });
}), on(signInSuccess, (state, user) => {
    return Object.assign(Object.assign({}, state), { loggedIn: true, inProgress: false, error: null, name: user.user_name, token: user.auth_token, permissions: user.permissions, step: Step.Authenticated });
}), on(userLoaded, (state, user) => {
    return Object.assign(Object.assign({}, state), { loggedIn: true, inProgress: false, error: null, name: user.user_name, permissions: user.permissions, token: user.auth_token, credentials: user.credentials, description: user.description, features: user.features, groups: user.groups, step: Step.Authenticated });
}), on(changePassword, state => {
    return Object.assign(Object.assign({}, state), { inProgress: true, step: Step.ChangePassword });
}), on(changePasswordSuccess, state => {
    return Object.assign(Object.assign({}, state), { inProgress: false, error: null, step: Step.ChangePassword });
}), on(changePasswordError, (state, { error }) => {
    return Object.assign(Object.assign({}, state), { inProgress: false, error, step: Step.ChangePassword });
}), on(sessionExpired, state => {
    return Object.assign(Object.assign({}, state), { loggedIn: false, error: null, step: Step.Unauthenticated });
}), on(signOut, (state, { error }) => {
    return Object.assign(Object.assign({}, initialState), { inProgress: false, error, step: Step.Unauthenticated });
}));
function aotState(state, action) {
    return reducer(state, action);
}

const selectUserState = createFeatureSelector(userFeatureKey);
const selectUsername = createSelector(selectUserState, state => state.name);
const selectUserError = createSelector(selectUserState, state => state.error);
const selectInProgress = createSelector(selectUserState, state => state.inProgress);
const selectLoggedIn = createSelector(selectUserState, state => state.loggedIn);
const selectAuthStep = createSelector(selectUserState, state => state.step);
const selectFeatures = createSelector(selectUserState, state => state.features);

var user_selectors = /*#__PURE__*/Object.freeze({
    __proto__: null,
    selectUserState: selectUserState,
    selectUsername: selectUsername,
    selectUserError: selectUserError,
    selectInProgress: selectInProgress,
    selectLoggedIn: selectLoggedIn,
    selectAuthStep: selectAuthStep,
    selectFeatures: selectFeatures
});

class UserService {
    constructor(handler, store, config) {
        this.store = store;
        this.config = config;
        this.http = new HttpClient(handler);
    }
    signIn(username, password) {
        return this.config.iamServer$.pipe(switchMap(host => {
            const body = { user_name: username, password };
            const url = `${host}/${UserService.BASE_PATH}/login`;
            return this.http.post(url, body);
        }));
    }
    getUserInfo(userId, token) {
        return this.config.iamServer$.pipe(switchMap(host => {
            const url = `${host}/${UserService.BASE_PATH}/authenticated-user-info`;
            return this.http.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
        }));
    }
    changePassword(username, password, newPassword) {
        return this.config.iamServer$.pipe(switchMap(host => {
            const url = `${host}/${UserService.BASE_PATH}/change-password`;
            const body = {
                user_name: username,
                old_password: password,
                new_password: newPassword
            };
            return this.http.post(url, body);
        }));
    }
    setSignOutTimer(expirationDuration) {
        this.clearSignOutTimer();
        this.signOutTimer = setTimeout(() => {
            this.store.dispatch(sessionExpired());
        }, expirationDuration);
    }
    clearSignOutTimer() {
        if (!this.signOutTimer) {
            return;
        }
        clearTimeout(this.signOutTimer);
    }
}
UserService.BASE_PATH = 'iam/v2';
UserService.ɵfac = function UserService_Factory(t) { return new (t || UserService)(ɵɵinject(HttpBackend), ɵɵinject(Store), ɵɵinject('config')); };
UserService.ɵprov = ɵɵdefineInjectable({ token: UserService, factory: UserService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UserService, [{
        type: Injectable
    }], function () { return [{ type: HttpBackend }, { type: Store }, { type: undefined, decorators: [{
                type: Inject,
                args: ['config']
            }] }]; }, null); })();

var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["USERNAME"] = "username";
    LocalStorageKeys["USER_ID"] = "user_id";
    LocalStorageKeys["TOKEN"] = "token";
})(LocalStorageKeys || (LocalStorageKeys = {}));
class UserEffects {
    constructor(actions$, userService) {
        this.actions$ = actions$;
        this.userService = userService;
        this.loadUser$ = createEffect(() => {
            return this.actions$.pipe(ofType(loadUser), concatMap(() => 
            /** An EMPTY observable only emits completion. Replace with your own observable API request */
            EMPTY.pipe(map(data => loadUserSuccess({ data })), catchError(error => of(loadUserFailure({ error }))))));
        });
        this.signIn$ = createEffect(() => {
            return this.actions$.pipe(ofType(signIn), switchMap(({ username, password }) => {
                return this.userService.signIn(username, password)
                    .pipe(map(user => signInSuccess(user)), catchError(error => of(signInFail({
                    error
                }))));
            }));
        });
        this.signInSuccess$ = createEffect(() => {
            return this.actions$.pipe(ofType(signInSuccess), switchMap(user => {
                const token = user.auth_token || localStorage.getItem(LocalStorageKeys.TOKEN);
                return this.userService.getUserInfo(user.user_id, token)
                    .pipe(tap(userDetails => {
                    localStorage.setItem(LocalStorageKeys.USERNAME, user.user_name);
                    localStorage.setItem(LocalStorageKeys.USER_ID, user.user_id);
                    if (user.auth_token) {
                        localStorage.setItem(LocalStorageKeys.TOKEN, token);
                    }
                }), switchMap(user => {
                    user.auth_token = localStorage.getItem(LocalStorageKeys.TOKEN);
                    this.autoSignOut(user.auth_token);
                    return of(userLoaded(user));
                }), catchError(error => of(loadUserFailure({ error }))));
            }));
        });
        this.changePassword$ = createEffect(() => {
            return this.actions$.pipe(ofType(changePassword), switchMap(({ username, password, newPassword }) => {
                return this.userService.changePassword(username, password, newPassword)
                    .pipe(map(success => changePasswordSuccess({ username, password: newPassword })), catchError(error => of(changePasswordError({ error }))));
            }));
        });
        this.autoSignInAfterPasswordChange$ = createEffect(() => {
            return this.actions$.pipe(ofType(changePasswordSuccess), switchMap(({ username, password }) => {
                return of(signIn({ username, password }));
            }));
        });
        this.expireSession$ = createEffect(() => {
            return this.actions$.pipe(ofType(loadUserFailure), switchMap(({ error }) => of(signOut({ error }))));
        });
        this.clearLocalStorage$ = createEffect(() => {
            return this.actions$.pipe(ofType(signOut), tap(() => {
                localStorage.removeItem(LocalStorageKeys.USERNAME);
                localStorage.removeItem(LocalStorageKeys.USER_ID);
                localStorage.removeItem(LocalStorageKeys.TOKEN);
            }));
        }, { dispatch: false });
        this.hydrate$ = createEffect(() => {
            return this.actions$.pipe(ofType('[AppState] Fetch App Config Success'), mapTo(({ userId: localStorage.getItem(LocalStorageKeys.USER_ID) })), switchMap(({ userId }) => {
                if (!userId) {
                    return of(noLocalUser());
                }
                else {
                    const token = localStorage.getItem(LocalStorageKeys.TOKEN);
                    return this.userService.getUserInfo(userId, token)
                        .pipe(map(user => {
                        return userLoaded(user);
                    }), catchError(error => of(loadUserFailure({ error }))));
                }
            }));
        });
        this.autoSignOut$ = createEffect(() => {
            return this.actions$.pipe(ofType(userLoaded), tap(() => {
                const token = localStorage.getItem(LocalStorageKeys.TOKEN);
                this.autoSignOut(token);
            }));
        }, {
            dispatch: false
        });
    }
    parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }
    ;
    autoSignOut(JWTToken) {
        const now = new Date().getTime();
        const jwt = this.parseJwt(JWTToken);
        const signOutDuration = Math.max(jwt.exp * 1000 - now, 0);
        this.userService.setSignOutTimer(signOutDuration);
    }
}
UserEffects.ɵfac = function UserEffects_Factory(t) { return new (t || UserEffects)(ɵɵinject(Actions), ɵɵinject(UserService)); };
UserEffects.ɵprov = ɵɵdefineInjectable({ token: UserEffects, factory: UserEffects.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UserEffects, [{
        type: Injectable
    }], function () { return [{ type: Actions }, { type: UserService }]; }, null); })();

class UserStoreModule {
}
UserStoreModule.ɵmod = ɵɵdefineNgModule({ type: UserStoreModule });
UserStoreModule.ɵinj = ɵɵdefineInjector({ factory: function UserStoreModule_Factory(t) { return new (t || UserStoreModule)(); }, providers: [
        UserService
    ], imports: [[
            CommonModule,
            StoreModule.forFeature(userFeatureKey, aotState),
            EffectsModule.forFeature([UserEffects])
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(UserStoreModule, { imports: [CommonModule, StoreFeatureModule, EffectsFeatureModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(UserStoreModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule,
                    StoreModule.forFeature(userFeatureKey, aotState),
                    EffectsModule.forFeature([UserEffects])
                ],
                providers: [
                    UserService
                ]
            }]
    }], null, null); })();

class AuthOutletDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
AuthOutletDirective.ɵfac = function AuthOutletDirective_Factory(t) { return new (t || AuthOutletDirective)(ɵɵdirectiveInject(ViewContainerRef)); };
AuthOutletDirective.ɵdir = ɵɵdefineDirective({ type: AuthOutletDirective, selectors: [["", "libAuthOutlet", ""]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthOutletDirective, [{
        type: Directive,
        args: [{
                selector: '[libAuthOutlet]'
            }]
    }], function () { return [{ type: ViewContainerRef }]; }, null); })();

const _c0 = ["username"];
const _c1 = ["password"];
const _c2 = ["newPassword1"];
const _c3 = ["newPassword2"];
const _c4 = ["button"];
class ChangePasswordComponent {
    constructor(store) {
        this.store = store;
        this.submitDisabled$ = new BehaviorSubject(true);
    }
    ngOnInit() {
        this.alive = true;
    }
    ngOnDestroy() {
        this.alive = false;
    }
    ngAfterViewInit() {
        this.formData$ = combineLatest([
            this.usernameInput.value$,
            this.passwordInput.value$,
            this.newPasswordInput1.value$,
            this.newPasswordInput2.value$
        ]);
        this.formData$.pipe(map(([username, password, new1, new2]) => {
            return !(!!username && !!password && !!new1 && !!new2 && new1 === new2);
        }), startWith(false), takeWhile(() => this.alive)).subscribe({
            next: disabled => this.submitDisabled$.next(disabled)
        });
        this.updateButton.click$.pipe(withLatestFrom(this.formData$), takeWhile(() => this.alive)).subscribe(([e, [username, password, new1, new2]]) => {
            if (new1 === new2) {
                this.store.dispatch(changePassword({ username, password, newPassword: new1 }));
            }
        });
    }
}
ChangePasswordComponent.ɵfac = function ChangePasswordComponent_Factory(t) { return new (t || ChangePasswordComponent)(ɵɵdirectiveInject(Store)); };
ChangePasswordComponent.ɵcmp = ɵɵdefineComponent({ type: ChangePasswordComponent, selectors: [["lib-change-password"]], viewQuery: function ChangePasswordComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0, true);
        ɵɵviewQuery(_c1, true);
        ɵɵviewQuery(_c2, true);
        ɵɵviewQuery(_c3, true);
        ɵɵviewQuery(_c4, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.usernameInput = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.passwordInput = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.newPasswordInput1 = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.newPasswordInput2 = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.updateButton = _t.first);
    } }, decls: 17, vars: 14, consts: [[3, "disabled"], ["button", ""], ["tabindex", "1", 3, "for", "label"], ["username", ""], ["tabindex", "2", 3, "for", "label", "inputType"], ["password", ""], ["tabindex", "3", 3, "for", "label", "inputType"], ["newPassword1", ""], ["tabindex", "4", 3, "for", "label", "inputType"], ["newPassword2", ""]], template: function ChangePasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "lib-card-header");
        ɵɵelementStart(1, "h3");
        ɵɵtext(2, "Change password");
        ɵɵelementEnd();
        ɵɵelementStart(3, "lib-button", 0, 1);
        ɵɵpipe(5, "async");
        ɵɵtext(6, "Update");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(7, "lib-card-content");
        ɵɵelementStart(8, "form");
        ɵɵelement(9, "lib-text-input", 2, 3);
        ɵɵelement(11, "lib-text-input", 4, 5);
        ɵɵelement(13, "lib-text-input", 6, 7);
        ɵɵelement(15, "lib-text-input", 8, 9);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("disabled", ɵɵpipeBind1(5, 12, ctx.submitDisabled$));
        ɵɵadvance(6);
        ɵɵproperty("for", "username")("label", "Username");
        ɵɵadvance(2);
        ɵɵproperty("for", "password")("label", "Password")("inputType", "password");
        ɵɵadvance(2);
        ɵɵproperty("for", "newPassword1")("label", "New Password")("inputType", "password");
        ɵɵadvance(2);
        ɵɵproperty("for", "newPassword2")("label", "Confirm Password")("inputType", "password");
    } }, directives: [CardHeaderComponent, ButtonComponent, CardContentComponent, TextInputComponent], pipes: [AsyncPipe], styles: ["[_nghost-%COMP%]{min-width:1200px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ChangePasswordComponent, [{
        type: Component,
        args: [{
                selector: 'lib-change-password',
                templateUrl: './change-password.component.html',
                styleUrls: ['./change-password.component.css']
            }]
    }], function () { return [{ type: Store }]; }, { usernameInput: [{
            type: ViewChild,
            args: ['username']
        }], passwordInput: [{
            type: ViewChild,
            args: ['password']
        }], newPasswordInput1: [{
            type: ViewChild,
            args: ['newPassword1']
        }], newPasswordInput2: [{
            type: ViewChild,
            args: ['newPassword2']
        }], updateButton: [{
            type: ViewChild,
            args: ['button']
        }] }); })();

const _c0$1 = ["button"];
const _c1$1 = ["username"];
const _c2$1 = ["password"];
const _c3$1 = ["form"];
const _c4$1 = function (a0) { return { "hidden": a0 }; };
class LoginComponent {
    constructor(store) {
        this.store = store;
        this.alive = true;
        this.submitDisabled$ = new BehaviorSubject(true);
        this.error$ = new BehaviorSubject(null);
        this.inProgress$ = this.store.select(selectInProgress);
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        const formData$ = combineLatest([
            this.usernameInput.value$,
            this.passwordInput.value$
        ]);
        const signIn$ = fromEvent(this.signInButton.nativeElement, 'click');
        const submit$ = fromEvent(this.formElement.nativeElement, 'keyup')
            .pipe(filter(e => e.key === 'Enter' || e.code === 'Enter'));
        this.store.select(selectUserError)
            .pipe(map(error => {
            var _a;
            if (!error) {
                return null;
            }
            return ((_a = error.error) === null || _a === void 0 ? void 0 : _a.description) || 'unknown error';
        }), tap(error => this.error$.next(error)), takeWhile(() => this.alive)).subscribe();
        formData$.pipe(tap(() => this.error$.next(null)), takeWhile(() => this.alive)).subscribe();
        combineLatest([
            this.usernameInput.empty$,
            this.passwordInput.empty$
        ]).pipe(tap(([noUser, noPass]) => {
            this.submitDisabled$.next(noUser || noPass);
        }), takeWhile(() => this.alive)).subscribe();
        this.handleSignIn(signIn$, formData$);
        this.handleSignIn(submit$, formData$);
    }
    ngOnDestroy() {
        this.alive = false;
    }
    handleSignIn(signIn$, form$) {
        signIn$.pipe(withLatestFrom(form$), tap(([clickEvent, [username, password]]) => {
            this.store.dispatch(signIn({
                username, password
            }));
        }), takeWhile(() => this.alive)).subscribe();
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵɵdirectiveInject(Store)); };
LoginComponent.ɵcmp = ɵɵdefineComponent({ type: LoginComponent, selectors: [["lib-login"]], viewQuery: function LoginComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$1, true);
        ɵɵviewQuery(_c1$1, true);
        ɵɵviewQuery(_c2$1, true);
        ɵɵviewQuery(_c3$1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.signInButton = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.usernameInput = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.passwordInput = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.formElement = _t.first);
    } }, decls: 16, vars: 15, consts: [[3, "disabled"], ["button", ""], [1, "card-content", 3, "ngClass"], ["id", "sign-in-form"], ["form", ""], ["tabindex", "1", 3, "for", "label"], ["username", ""], ["tabindex", "2", 3, "for", "label", "inputType"], ["password", ""]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "lib-card-header");
        ɵɵelementStart(1, "h3");
        ɵɵtext(2, "Sign In");
        ɵɵelementEnd();
        ɵɵelementStart(3, "button", 0, 1);
        ɵɵpipe(5, "async");
        ɵɵpipe(6, "async");
        ɵɵtext(7, "Submit");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "lib-card-content", 2);
        ɵɵpipe(9, "async");
        ɵɵelementStart(10, "form", 3, 4);
        ɵɵelement(12, "lib-text-input", 5, 6);
        ɵɵelement(14, "lib-text-input", 7, 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("disabled", ɵɵpipeBind1(5, 7, ctx.submitDisabled$) || ɵɵpipeBind1(6, 9, ctx.inProgress$));
        ɵɵadvance(5);
        ɵɵproperty("ngClass", ɵɵpureFunction1(13, _c4$1, ɵɵpipeBind1(9, 11, ctx.inProgress$)));
        ɵɵadvance(4);
        ɵɵproperty("for", "username")("label", "Username");
        ɵɵadvance(2);
        ɵɵproperty("for", "password")("label", "Password")("inputType", "password");
    } }, directives: [CardHeaderComponent, CardContentComponent, NgClass, TextInputComponent], pipes: [AsyncPipe], styles: [".sign-in-card[_ngcontent-%COMP%]{min-width:1200px}form[_ngcontent-%COMP%]{display:flex;flex-direction:column}form[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:text;width:100%}form[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%], form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{border:solid var(--almost-black);border-width:0 0 1px;margin-bottom:2em;margin-top:0;padding:0;transition:border-color .25s,margin-top .1s}form[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus, form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus{border-color:var(--blue);margin-top:1em;outline:none}button[_ngcontent-%COMP%]{background-color:var(--yellow);border:none;border-radius:4px;cursor:pointer;font-weight:700;padding:.5em;transition:background-color .25s,color .25s}button[_ngcontent-%COMP%]:hover{background-color:#ffd782}button[_ngcontent-%COMP%]:disabled{background-color:grey;color:#a9a9a9;cursor:default}.card-content[_ngcontent-%COMP%]{display:block;max-height:300px;overflow:hidden;transition:max-height .25s,padding .25s}.card-content.hidden[_ngcontent-%COMP%]{max-height:0;padding:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'lib-login',
                templateUrl: './login.component.html',
                styleUrls: ['./login.component.scss']
            }]
    }], function () { return [{ type: Store }]; }, { signInButton: [{
            type: ViewChild,
            args: ['button']
        }], usernameInput: [{
            type: ViewChild,
            args: ['username']
        }], passwordInput: [{
            type: ViewChild,
            args: ['password']
        }], formElement: [{
            type: ViewChild,
            args: ['form']
        }] }); })();

function AuthComponent_ng_template_1_Template(rf, ctx) { }
function AuthComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 4);
} }
function AuthComponent_ng_container_4_lib_card_content_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "lib-card-content");
    ɵɵelementStart(1, "p", 5);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const error_r4 = ctx.ngIf;
    ɵɵadvance(2);
    ɵɵtextInterpolate(error_r4);
} }
function AuthComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AuthComponent_ng_container_4_lib_card_content_1_Template, 3, 1, "lib-card-content", 3);
    ɵɵpipe(2, "async");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ɵɵpipeBind1(2, 1, ctx_r2.error$));
} }
class AuthComponent {
    constructor(store, resolver) {
        this.store = store;
        this.resolver = resolver;
        this.alive = true;
        this.inProgress$ = this.store.select(selectInProgress);
        this.step$ = this.store.select(selectAuthStep);
        this.error$ = new BehaviorSubject(null);
    }
    ngOnDestroy() {
        this.alive = false;
    }
    ngAfterViewInit() {
        this.store.select(selectUserError)
            .pipe(map(error => {
            var _a;
            if (!error) {
                return null;
            }
            if (error.status === 0 && error.headers && Object.keys(error.headers.headers).length === 0) {
                const url = new URL(error.url);
                return `${url.host} is unreachable.`;
            }
            return ((_a = error.error) === null || _a === void 0 ? void 0 : _a.description) || error.message || 'unknown error';
        }), tap(error => this.error$.next(error)), takeWhile(() => this.alive)).subscribe();
    }
    ngOnInit() {
        this.step$.pipe(takeWhile(() => this.alive)).subscribe((step) => {
            switch (step) {
                case Step.Unauthenticated:
                    this.setContent(LoginComponent);
                    break;
                case Step.ChangePassword:
                    this.setContent(ChangePasswordComponent);
                default:
                    break;
            }
        });
    }
    setContent(content) {
        const factory = this.resolver.resolveComponentFactory(content);
        const ref = this.outlet.viewContainerRef;
        ref.clear();
        return ref.createComponent(factory);
    }
}
AuthComponent.ɵfac = function AuthComponent_Factory(t) { return new (t || AuthComponent)(ɵɵdirectiveInject(Store), ɵɵdirectiveInject(ComponentFactoryResolver)); };
AuthComponent.ɵcmp = ɵɵdefineComponent({ type: AuthComponent, selectors: [["lib-auth"]], viewQuery: function AuthComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(AuthOutletDirective, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.outlet = _t.first);
    } }, decls: 9, vars: 6, consts: [[1, "card"], ["libAuthOutlet", ""], ["class", "progress-line", 4, "ngIf"], [4, "ngIf"], [1, "progress-line"], [1, "error"]], template: function AuthComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "lib-card", 0);
        ɵɵtemplate(1, AuthComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
        ɵɵtemplate(2, AuthComponent_div_2_Template, 1, 0, "div", 2);
        ɵɵpipe(3, "async");
        ɵɵtemplate(4, AuthComponent_ng_container_4_Template, 3, 3, "ng-container", 3);
        ɵɵpipe(5, "async");
        ɵɵelementStart(6, "lib-card-footer");
        ɵɵelementStart(7, "small");
        ɵɵtext(8, "unauthorized access prohibited");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ɵɵpipeBind1(3, 2, ctx.inProgress$));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ɵɵpipeBind1(5, 4, ctx.step$) !== "[Unauthenticated]");
    } }, directives: [CardComponent, AuthOutletDirective, NgIf, CardFooterComponent, CardContentComponent], pipes: [AsyncPipe], styles: ["[_nghost-%COMP%]{align-items:center;display:flex;justify-content:center}.card[_ngcontent-%COMP%]{min-width:1200px}.error[_ngcontent-%COMP%]{color:red}.footer[_ngcontent-%COMP%]   small[_ngcontent-%COMP%]{color:var(--grey);font-size:1rem}.progress-line[_ngcontent-%COMP%], .progress-line[_ngcontent-%COMP%]:before{height:6px;margin:0;width:100%}.progress-line[_ngcontent-%COMP%]{background-color:#e0efff;display:flex}.progress-line[_ngcontent-%COMP%]:before{-webkit-animation:running-progress 2s cubic-bezier(.4,0,.2,1) infinite;animation:running-progress 2s cubic-bezier(.4,0,.2,1) infinite;background-color:#2286fc;content:\"\"}@-webkit-keyframes running-progress{0%{margin-left:0;margin-right:100%}50%{margin-left:25%;margin-right:0}to{margin-left:100%;margin-right:0}}@keyframes running-progress{0%{margin-left:0;margin-right:100%}50%{margin-left:25%;margin-right:0}to{margin-left:100%;margin-right:0}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthComponent, [{
        type: Component,
        args: [{
                selector: 'lib-auth',
                templateUrl: './auth.component.html',
                styleUrls: ['./auth.component.scss']
            }]
    }], function () { return [{ type: Store }, { type: ComponentFactoryResolver }]; }, { outlet: [{
            type: ViewChild,
            args: [AuthOutletDirective, { static: true }]
        }] }); })();

const routes = [
    {
        path: '',
        component: AuthComponent
    }
];
class AuthRoutingModule {
}
AuthRoutingModule.ɵmod = ɵɵdefineNgModule({ type: AuthRoutingModule });
AuthRoutingModule.ɵinj = ɵɵdefineInjector({ factory: function AuthRoutingModule_Factory(t) { return new (t || AuthRoutingModule)(); }, imports: [[RouterModule.forChild(routes)], RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AuthRoutingModule, { imports: [RouterModule], exports: [RouterModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(routes)],
                exports: [RouterModule]
            }]
    }], null, null); })();

class AuthModule {
}
AuthModule.ɵmod = ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = ɵɵdefineInjector({ factory: function AuthModule_Factory(t) { return new (t || AuthModule)(); }, imports: [[
            CommonModule,
            HttpClientModule,
            AuthRoutingModule,
            CardModule,
            TextInputModule,
            UserStoreModule,
            ButtonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AuthModule, { declarations: [LoginComponent,
        ChangePasswordComponent,
        AuthComponent,
        AuthOutletDirective], imports: [CommonModule,
        HttpClientModule,
        AuthRoutingModule,
        CardModule,
        TextInputModule,
        UserStoreModule,
        ButtonModule], exports: [AuthComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LoginComponent,
                    ChangePasswordComponent,
                    AuthComponent,
                    AuthOutletDirective
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    AuthRoutingModule,
                    CardModule,
                    TextInputModule,
                    UserStoreModule,
                    ButtonModule
                ],
                exports: [
                    AuthComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of pages-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthComponent, AuthModule, user_actions as UserActions, user_selectors as UserSelectors, UserStoreModule };
//# sourceMappingURL=pages-lib.js.map
